var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveSetup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8356 20.75C9.19591 18.4097 12.3114 18.1338 14.0857 19.9221C14.4824 20.3219 14.6807 20.522 14.8566 20.5459C15.0326 20.5698 16.1364 19.9367 16.5282 19.7121C16.9276 19.4831 18.035 18.8479 18.1046 18.6817C18.1742 18.5155 18.1014 18.2322 17.9557 17.6656C17.4257 15.6052 18.7108 13.4369 20.7641 12.8776C21.3136 12.7279 21.5882 12.6531 21.6968 12.51C21.8053 12.3669 21.8053 11.1087 21.8053 10.6483C21.8053 10.188 21.8053 8.92966 21.6968 8.78658C21.5882 8.64351 21.3136 8.56865 20.7641 8.41903C18.7105 7.85974 17.4243 5.69142 17.9541 3.63096C18.0997 3.06426 18.1725 2.78091 18.1029 2.61476C18.0334 2.44862 16.9259 1.81348 16.5266 1.58447C16.1347 1.35975 15.0309 0.726741 14.8551 0.75066C14.6791 0.7746 14.4808 0.974509 14.084 1.37435C12.5477 2.92236 10.0059 2.92242 8.46967 1.37444C8.07288 0.974614 7.87447 0.774695 7.69862 0.750776C7.52276 0.726846 6.41896 1.35986 6.02709 1.5846C5.62775 1.81362 4.52023 2.44874 4.45064 2.61491C4.38106 2.78108 4.45393 3.06439 4.59967 3.63104C5.12959 5.69143 3.8445 7.8597 1.79121 8.41901C1.24176 8.56865 0.967028 8.64351 0.858519 8.78669C0.75 8.92966 0.75 10.188 0.75 10.6483C0.75 11.1087 0.75 12.3669 0.858519 12.5101C0.967049 12.6532 1.24164 12.7279 1.79083 12.8775C1.79727 12.8793 1.8037 12.8811 1.81013 12.8828",
    stroke: "url(#paint0_linear_9663_4580)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26471 17.2592C2.40169 16.1228 6.26745 12.2965 6.64644 11.8544C7.04709 11.3872 6.72224 10.7559 6.91553 8.79848C7.00906 7.85143 7.21287 7.14189 7.79606 6.61389C8.49089 5.95724 9.05938 5.95724 11.0175 5.91303C12.723 5.95724 12.9251 5.76781 13.102 6.20979C13.2283 6.5255 12.8493 6.71491 12.3945 7.22004C11.3839 8.23027 10.7901 8.73542 10.7333 9.05114C10.3227 10.4402 11.9397 11.261 12.8241 10.377C13.1585 10.0427 14.7064 8.48283 14.858 8.35655C14.9717 8.25553 15.2438 8.26041 15.376 8.41969C15.4897 8.53134 15.5023 8.54596 15.4897 9.05104C15.478 9.51868 15.4832 10.1899 15.4846 10.8821C15.4865 11.7791 15.4391 12.7764 15.0601 13.2815C14.3021 14.4179 13.0388 14.4811 11.9018 14.5316C10.828 14.5948 9.94369 14.4811 9.66576 14.6831C9.43837 14.7968 8.23822 16.0596 6.78541 17.5118L4.19561 20.1005C2.04796 21.8054 -0.31444 19.1535 1.26471 17.2592Z",
    stroke: "url(#paint1_linear_9663_4580)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9663_4580",
    x1: 5.97451,
    y1: 1.95038,
    x2: 15.5947,
    y2: 19.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9663_4580",
    x1: 4.40837,
    y1: 6.79379,
    x2: 11.6883,
    y2: 19.4073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSetup);
export default __webpack_public_path__ + "static/media/ActiveSetup.7be85d085fb746992e592c0b816ae436.svg";
export { ForwardRef as ReactComponent };